// extracted by mini-css-extract-plugin
module.exports = {"modalInputLabel":"_3VBMlfKo","blockedEmailText":"KoAtHeBI"};